import React from "react";
import "./Concepts.css";
import conceptList from "../data/conceptList";
import { useAlert } from "../context/AlertContext"; // ✅ eklendi

function ConceptSelectorModal({ isOpen, onClose, onSelectConceptWithItems }) {
  const { showSuccess } = useAlert(); // ✅ hazırlandı

  if (!isOpen) return null;

  const handleSelect = (concept) => {
    onSelectConceptWithItems(concept.name, concept.defaultItems || []);

    // 🔔 Eğer kullanıcıya mesaj vermek istersen:
    // showSuccess(`"${concept.name}" konsepti seçildi`, "", { emoji: "🎨" });
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3>Konsept Seç</h3>
        <div className="concept-grid">
          {conceptList.map((concept, index) => (
            <div
              key={index}
              className="concept-item"
              onClick={() => handleSelect(concept)}
            >
              <img src={concept.image} alt={concept.name} />
              <p>{concept.name}</p>
            </div>
          ))}
        </div>
        <button onClick={onClose} className="close-button">
          Kapat
        </button>
      </div>
    </div>
  );
}

export default ConceptSelectorModal;
